import {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import {Trans, useTranslation} from 'react-i18next';
import {
  Avatar,
  Box,
  Button,
  ButtonBase,
  ButtonGroup,
  Link,
  Toolbar,
  Typography,
  Stack,
  LinearProgress
} from '@mui/material';
// project imports
import Logo from 'ui-component/Logo';
import {styled} from "@mui/styles";
import defaultLanguage from 'i18n/defaultLanguage';
import * as Api from 'api';
import {useSelector} from "react-redux";
import useNavigateParams from "hooks/useNavigateParams";
import useUserinfo from "hooks/useUserinfo";
import LanguageSection from "./LanguageSection";

import {linearProgressClasses} from "@mui/material/LinearProgress";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === 'light' ? '#6040B0' : '#6040B0',
  }
}));
const Header = () => {
  const userinfo = useSelector((state) => state.userinfo);
  const theme = useTheme();
  const navigate = useNavigateParams();
  useUserinfo();

  const handlerlogin = () => {
    navigate('/login');
  };

  const handlersign = () => {
    navigate('/register');
  };

  const handlerGallery = () => {
    navigate('/square');
  }

  const handlerpanit = () => {
    navigate('/paint');
  };


  const handlerhome = () => {
    navigate('/');
  };
  const handlerdiscord = () => {
    window.location.href = "https://discord.com/invite/uMg5R6qkXc"
  };

  const handlerValentine = () => {
    location.replace('/valentine');
  };

  return (
    <Toolbar
      sx={{
        height: '55px',
      }}
    >
      {/* logo & toggler button */}
      <Box display="flex" gap={3} alignItems="center">
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <Logo pathname={"home"}/>
        </Box>
      </Box>
      {userinfo.username ? (
        <Stack
          direction='row'
          sx={{
            position: 'absolute',
            right: '-3.5%',
            display: 'flex',
            float: 'right',
            transform: 'translatex(-20%)'
          }}
        >
          <ButtonGroup aria-label="outlined button group">
            <Box>
              <Button sx={{ color:"#6040B0"}} variant="text" onClick={handlerhome}><Trans i18nKey="index.home">{ defaultLanguage.index.home }</Trans></Button>
              <BorderLinearProgress
                variant="determinate"
                color="secondary"
                value={100}
                sx={{
                  ml: 1.5,
                  mr: 1.5,
                  mt: -1,
                  backgroundColor: '#6040B0'
                }}/>
            </Box>
            <Button sx={{ color:"#4D4D4D" }} variant="text" onClick={handlerpanit}><Trans i18nKey="index.generate">{ defaultLanguage.index.generate }</Trans></Button>
            <Button sx={{ color:"#4D4D4D", ml:1}} variant="text" onClick={handlerGallery}><Trans i18nKey="index.gallery">{ defaultLanguage.index.gallery }</Trans></Button>
            <Button sx={{ color:"#4D4D4D" }} variant="text" onClick={handlerdiscord}><Trans i18nKey="index.discord">{ defaultLanguage.index.discord }</Trans></Button>
          </ButtonGroup>
          <LanguageSection formMargin={0.8}></LanguageSection>
          <Typography
            sx={{
              mt: 1,
              alignItems: 'center',
              color:"#4D4D4D"
            }}
          >
            {`Hi, ` + userinfo.username}
          </Typography>
        </Stack>
      ) : (
        <Stack
          direction='row'
          sx={{
            position: 'absolute',
            right: '-3%',
            transform: 'translatex(-50%)'
          }}
        >
          <LanguageSection formMargin={0.25}></LanguageSection>
          <Link
            underline="hover"
            color="inherit"
            component="button"
          >
            <Typography
              onClick={handlerlogin}
              sx={{ color:"#4D4D4D" }}
              variant="button"
              display="block"
              gutterBottom
              align='right'
            >
              <Trans i18nKey="user.login_lable">{ defaultLanguage.user.login_lable }</Trans>
            </Typography>
          </Link>
          <Typography
            sx={{ color:"#4D4D4D", lineHeight: 1.8}}
            display="block"
            gutterBottom
            align='right'
          >
            /
          </Typography>
          <Link underline="hover" color="inherit" component="button">
            <Typography
              sx={{ color:"#4D4D4D"}}
              variant="button"
              display="block"
              onClick={handlersign}
              gutterBottom
              align='right'
            >
              <Trans i18nKey="user.register_lable">{ defaultLanguage.user.register_lable }</Trans>
            </Typography>
          </Link>
        </Stack>
      )}

    </Toolbar>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
